import React 			from 'react'
import renderHTML 		from 'react-render-html'

import SectionSpacer 	from '../../../section-spacer'
import {
	TextBlock
} from '../../../text-block'
import Video 			from '../../../video'

import Section, {
	SectionCols
} from '../section'

export default (props) => {
	const {
		heading,
		video
	} = props

	return <Section
		type="text"
		>
		{ heading ? <SectionCols
			indent={ true }
			>
			<TextBlock
				>
				<h4>{ renderHTML(heading) }</h4>
			</TextBlock>
			{ video ? <SectionSpacer space={ 0.5 } /> : null }
		</SectionCols> : null }
		{ video ? <Video
			video={ video } /> : null }
	</Section>
}